import React, { useState, useEffect } from "react";
import moment from "moment";
import customFetch from "./apicall/api";
import { DatePicker, Select, Input, Row, Col } from "antd";

const { RangePicker } = DatePicker;

const DynamicForm = ({
  reportConfig, setReportConfig,
  currentReportId, formState, setFormState,
  setErrorWindowActive, setErrorWindowMessage,
  isFormLoading, setIsFormLoading 
}) => {
  
  useEffect(()=>{
    console.log("nut:",reportConfig, currentReportId)
    console.log("nut: this is loading")
    const setupConfig = async () => {
      try {
        // setIsFormLoading(true)
        const result = await fetchReportConfig(currentReportId);
        if (result) {
          if (!result.error) {
            if (result.config) {
              setReportConfig(result.config);
            }
            initializeFormState(result.config);
          }
        }
        // setIsFormLoading(false)
      } catch (error) {
        // setIsFormLoading(false)
        console.error(error);
      }
    }
    setupConfig();
    initializeFormState(reportConfig)
  },[])
  
  
  const initializeFormState = (config) => {
    const initialState = {};

    const isEmptyCondition = (condition) => {
      return !condition || (Array.isArray(condition) && condition.length === 0);
    };

    config && Object.keys(config).forEach((key) => {
      const configItem = config[key]
      let visibleState = false
      if (configItem.source === "API") {
        visibleState = isEmptyCondition(configItem.visibility_conditions) &&
          isEmptyCondition(configItem.query_dependencies);
      } else {
        visibleState = isEmptyCondition(configItem.visibility_conditions);
      }
      initialState[key] = {
        id: "",
        value: "",
        isVisible: visibleState,
        isFetching: false,
      };
    })
    setFormState(initialState);
  };
  
  const fetchReportConfig = async (reportId) => {
    try {
      const response = await customFetch(
        `${process.env.REACT_APP_URL}/get/parameters?report_id=${reportId}`,
        {
          method: "GET"
        }
      );

      if (!response.ok) throw new Error("Failed to fetch report config");

      const data = await response.json();

      if (data && data.length > 0) {
        data[0].report_config = JSON.parse(data[0].report_config);

        const processedConfigArray = await Promise.all(
          Object.keys(data[0].report_config).map(async (key) => {
            const configItem = data[0].report_config[key];
            const state = initialFetchState(configItem);

            if (state == 1) {
              const processedItem = await processAPIConfigItem(key, configItem, data[0].report_id);
              return { key, value: processedItem, include: true };
            }
            return { key, value: configItem, include: state != -1 };
          })
        );

        const structuredConfig = Object.fromEntries(
          processedConfigArray.filter(item => item.include).map(item => [item.key, item.value])
        );

        const skippedConfig = Object.fromEntries(
          processedConfigArray.filter(item => !item.include).map(item => [item.key, item.value])
        );

        // Separate fields with and without 'order' field
        const fieldsWithOrder = Object.keys(structuredConfig)
          .filter(key => structuredConfig[key].order !== undefined) // fields with 'order'
          .map(key => ({ key, ...structuredConfig[key] }));

        const fieldsWithoutOrder = Object.keys(structuredConfig)
          .filter(key => structuredConfig[key].order === undefined) // fields without 'order'
          .map(key => ({ key, ...structuredConfig[key] }));

        // Sort the fields with 'order' by the 'order' field
        const sortedFieldsWithOrder = fieldsWithOrder.sort((a, b) => (a.order || 0) - (b.order || 0));

        // Combine fields with 'order' and fields without 'order' (fields without order remain in original order)
        const finalSortedConfig = [...sortedFieldsWithOrder, ...fieldsWithoutOrder];

        // Convert the sorted array back to an object
        const finalSortedConfigObj = Object.fromEntries(finalSortedConfig.map(({ key, ...rest }) => [key, rest]));

        return {
          config: finalSortedConfigObj,
          skippedConfig,
          error: false
        }
      }

      return null;
    } catch (error) {
      setErrorWindowActive(true)
      setErrorWindowMessage("Error fetching report config:" + error)
      console.error("Error fetching report config:", error);
      return { error: true }
    }
  };
  
  const initialFetchState = (configItem) => {
    if (typeof configItem != "object" || configItem === null) return -1
    if (configItem.type === "textbox" || configItem.source !== "API") return 0
    if (configItem.source === "API") {
      // return (!configItem.visibility_conditions || (Array.isArray(configItem.visibility_conditions && configItem.visibility_conditions.length === 0))) &&
      //   (!configItem.query_dependencies || (Array.isArray(configItem.query_dependencies && configItem.query_dependencies.length === 0)))
      const noQueryDependencies = !configItem.query_dependencies || (Array.isArray(configItem.query_dependencies) && configItem.query_dependencies.length === 0)
      return noQueryDependencies ? 1 : 0
    }
    return 1
  }
  const processAPIConfigItem = async (configKey, configItem, reportId, dependentValues) => {
    try {
      const body = {
        keyname: configKey,
        params: dependentValues || [],
      };

      const response = await customFetch(
        `${process.env.REACT_APP_URL}/reports/${reportId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch API config data");

      const result = await response.json();
      const apiData = result.data || [];

      let updatedItem = { ...configItem };

      // Generic handling for dropdowns and other field types
      switch (configItem.type) {
        case "Dropdown":
          updatedItem = {
            ...configItem,
            options: apiData.map((item) => ({
              label: item.id,
              value: item.datakey,
            })),
          };
          break;

        case "textbox":
          updatedItem = {
            ...configItem,
            status: result.status,
          };
          if (result.status === 1) {
          }
          break;

        default:
          updatedItem = {
            ...configItem,
            ...apiData[0],
          };
          break;
      }

      return updatedItem;

    } catch (error) {
      setErrorWindowMessage(`Error fetching data: ${error.message}`);
      setErrorWindowActive(true);

      throw error;
    }
  };

  const handleInputChange = async (key, newValue, forceSelfAPICall = false) => {
    const updatedFormState = { ...formState };
    const updatedReportConfig = { ...reportConfig };

    const resetDependentFields = (parentKey) => {
      Object.keys(updatedReportConfig).forEach(function (fieldKey) {
        const fieldConfig = updatedReportConfig[fieldKey];

        const hasVisibilityCondition = fieldConfig.visibility_conditions &&
          fieldConfig.visibility_conditions.some(function (condition) {
            return condition.parent_key === parentKey;
          });

        const hasQueryDependency = fieldConfig.query_dependencies &&
          fieldConfig.query_dependencies.includes(parentKey);

        if (hasVisibilityCondition || hasQueryDependency) {
          updatedFormState[fieldKey].value = null;
          updatedFormState[fieldKey].id = null;
          updatedFormState[fieldKey].isVisible = false;

          resetDependentFields(fieldKey);
        }
      });
    };

    // Function to update visibility recursively
    const updateVisibility = (fieldKey, visitedFields) => {
      if (visitedFields.includes(fieldKey)) {
        console.warn(`Circular dependency detected involving: ${fieldKey}`);
        return;
      }

      visitedFields.push(fieldKey);

      const fieldConfig = updatedReportConfig[fieldKey];
      if (!fieldConfig || !fieldConfig.visibility_conditions) return;

      // Check visibility conditions
      const isVisible = fieldConfig.visibility_conditions.every(function (condition) {
        const parentValue = updatedFormState[condition.parent_key]
          ? updatedFormState[condition.parent_key].id
          : null;

        return (
          parentValue !== null &&
          parentValue !== "" &&
          (!condition.allowed || condition.allowed.indexOf(parentValue) >= 0)
        );
      });

      // Add query_dependencies check
      const dependenciesSatisfied = fieldConfig.query_dependencies
        ? fieldConfig.query_dependencies.every((depKey) => {
          const depValue = updatedFormState[depKey] ? updatedFormState[depKey].value : null;
          return depValue !== null && depValue !== "";
        })
        : true;

      const finalVisibility = isVisible && dependenciesSatisfied;

      // Update visibility in the form state
      if (updatedFormState[fieldKey].isVisible !== finalVisibility) {
        updatedFormState[fieldKey].isVisible = finalVisibility;

        // If visibility changes to false, clear the field's value
        if (!finalVisibility) {
          updatedFormState[fieldKey].value = null;
          updatedFormState[fieldKey].id = null;
          resetDependentFields(fieldKey);
        }

        // If visibility changes, process dependent fields
        if (finalVisibility) {
          Object.keys(updatedReportConfig).forEach(function (dependentKey) {
            if (
              updatedReportConfig[dependentKey].visibility_conditions &&
              updatedReportConfig[dependentKey].visibility_conditions.some(function (cond) {
                return cond.parent_key === fieldKey;
              })
            ) {
              updateVisibility(dependentKey, visitedFields.slice()); // Pass a copy of the visited list
            }
          });
        }
      }
    };


    // Update the value of the current field, also adding the id
    const fieldConfig = updatedReportConfig[key];
    const foundOption = fieldConfig.options && fieldConfig.options.find(function (option) {
      return option.value === newValue;
    });
    const id = foundOption ? foundOption.label : newValue;
    updatedFormState[key] = {
      ...updatedFormState[key],
      value: newValue,
      id: id || newValue,
    };

    resetDependentFields(key)

    // Update visibility recursively
    Object.keys(updatedReportConfig).forEach(function (fieldKey) {
      const hasParentDependency = updatedReportConfig[fieldKey].visibility_conditions &&
        updatedReportConfig[fieldKey].visibility_conditions.some(function (cond) {
          return cond.parent_key === key;
        });

      const hasQueryDependency = updatedReportConfig[fieldKey].query_dependencies &&
        updatedReportConfig[fieldKey].query_dependencies.includes(key);

      if (hasParentDependency || hasQueryDependency) {
        updateVisibility(fieldKey, []);
      }
    });

    // Update form state
    setFormState(updatedFormState);

    // Handle API calls only for fields that meet the conditions
    const fieldsToFetch = Object.keys(updatedReportConfig).filter(function (fieldKey) {
      const fieldConfig = updatedReportConfig[fieldKey];

      // Check if the field has source: API
      const isSourceAPI = fieldConfig.source === "API";

      // Check if query_dependencies exist and are satisfied
      const dependenciesSatisfied = fieldConfig.query_dependencies
        ? fieldConfig.query_dependencies.every((depKey) => {
          return updatedFormState[depKey] && updatedFormState[depKey].value;
        })
        : true;

      // Check if the field is visible
      const isVisible = updatedFormState[fieldKey] && updatedFormState[fieldKey].isVisible;

      // Check if the field state has changed compared to the previous formState
      const hasChanged =
        (!fieldConfig.query_dependencies &&
          JSON.stringify(formState[fieldKey]) !== JSON.stringify(updatedFormState[fieldKey]))
        ||
        (fieldConfig.query_dependencies &&
          fieldConfig.query_dependencies.some(function (depKey) {
            return (
              formState[depKey] &&
              updatedFormState[depKey] &&
              JSON.stringify(formState[depKey].value) !== JSON.stringify(updatedFormState[depKey].value)
            );
          }));

      if (forceSelfAPICall && fieldKey === key) return isSourceAPI && dependenciesSatisfied && isVisible
      return isSourceAPI && dependenciesSatisfied && isVisible && hasChanged && fieldKey !== key;
    });

    // Make API calls for the fields that need it
    const fetchPromises = fieldsToFetch.map(async (fieldKey) => {
      const fieldConfig = updatedReportConfig[fieldKey];
      const dependentValues = fieldConfig.query_dependencies
        ? fieldConfig.query_dependencies.map(function (depKey) {
          return updatedFormState[depKey].id;
        })
        : [];

      if (fieldKey === key && fieldConfig.type === "textbox") dependentValues.push(updatedFormState[key].value)

      // Optionally show a loading indicator for the field
      setFormState((prevState) => ({
        ...prevState,
        [fieldKey]: { ...prevState[fieldKey], isFetching: true },
      }));

      try {
        // Fetch updated configuration for the field
        const processedItem = await processAPIConfigItem(
          fieldKey,
          fieldConfig,
          currentReportId,
          dependentValues
        );

        // Update the reportConfig with new configuration
        updatedReportConfig[fieldKey] = {
          ...updatedReportConfig[fieldKey],
          ...processedItem,
        };

        // Update the global state for reportConfig
        setReportConfig(updatedReportConfig);
      } catch (error) {
        // Handle errors (e.g., showing an error message)
        setErrorWindowActive(true);
        setErrorWindowMessage(`Error updating field: ${error.message}`);
      } finally {
        setFormState((prevState) => ({
          ...prevState,
          [fieldKey]: { ...prevState[fieldKey], isFetching: false },
        }));
      }
    });

    // Execute all the fetch requests in parallel
    await Promise.all(fetchPromises);
  };

  const handleTextboxChange = (key, newValue) => {
    const updatedFormState = { ...formState };
    updatedFormState[key] = { ...updatedFormState[key], value: newValue, id: newValue };
    setFormState(updatedFormState);
  };

  const getDisabledDateRange = (current, field, addType = "days") => {
    current = moment(current);

    const parseNumber = (value) => {
      const num = Number(value);
      return !isNaN(num) ? num : null;
    };

    const toMaxDate = field.to_max_date !== undefined && field.to_max_date !== null
      ? (parseNumber(field.to_max_date) !== null
        ? moment().add(parseNumber(field.to_max_date), addType)
        : moment(field.to_max_date))
      : null;

    const fromMaxDate = field.from_max_date !== undefined && field.from_max_date !== null
      ? (parseNumber(field.from_max_date) !== null
        ? moment().subtract(parseNumber(field.from_max_date), addType)
        : moment(field.from_max_date))
      : null;

    const defaultStartDate = field.default_start_dt
      ? moment(field.default_start_dt)
      : null;

    return (
      current &&
      (
        (defaultStartDate && current.isBefore(defaultStartDate)) ||
        (toMaxDate && current.isAfter(toMaxDate)) ||
        (fromMaxDate && current.isBefore(fromMaxDate))
      )
    );
  };
  
  return (
    reportConfig && 
    <Row gutter={16} style={{ flexWrap: "wrap" }}>
      {Object.keys(reportConfig).map(function (key) {
        const field = reportConfig[key];
        if (!formState[key] || !formState[key].isVisible) return null;

        switch (field.type) {
          case "Dropdown":
            return (
              <Col key={key} span={8} style={{ marginBottom: 24 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label style={{ marginBottom: 4, fontWeight: 500 }}>{field.label || key}</label>
                  <Select
                    id={key}
                    value={formState[key].value || undefined}
                    onChange={(value) => handleInputChange(key, value)}
                    placeholder="Select"
                    style={{ width: "100%" }}
                    loading={formState[key].isFetching}
                    allowClear
                  >
                    {field.options && field.options.length > 0 && field.options.map((option) => (
                      <Select.Option key={option.value} value={option.value}>
                        {option.value}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </Col>
            );

          case "calendar_date":
            return (
              <Col key={key} span={8} style={{ marginBottom: 24 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label style={{ marginBottom: 4, fontWeight: 500 }}>{field.label}</label>
                  <DatePicker
                    value={(formState[key] && formState[key].value) ?
                      moment(formState[key].value)
                      : null
                    }
                    format={"YYYY-MM-DD"}
                    className="antd_dateform-control"
                    placeholder="Select Date"
                    onChange={(e) => {
                      let selectedDate = null;
                      if (e) {
                        selectedDate = moment(e).format("YYYY-MM-DD");
                      }
                      handleInputChange(key, selectedDate);
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field)}
                    style={{ width: "100%" }}
                  />
                </div>
              </Col>
            );

          case "calendar_daterange":
            return (
              <Col key={key} span={8} style={{ marginBottom: 24 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label style={{ marginBottom: 4, fontWeight: 500 }}>{field.label}</label>
                  <RangePicker
                    value={(formState[key] && formState[key].value) ? [
                      moment(formState[key].value[0]),
                      moment(formState[key].value[1])
                    ] : null}
                    format={"YYYY-MM-DD"}
                    className="antd_dateform-control"
                    placeholder={["Start Date", "End Date"]}
                    onChange={(e) => {
                      if (e && e.length === 2) {
                        const startDate = moment(e[0]);
                        const endDate = moment(e[1]);

                        // Check the gap condition
                        if (field.gap && endDate.diff(startDate, "days") > field.gap) {
                          setErrorWindowActive(true);
                          setErrorWindowMessage(
                            field.error_message
                              ? field.error_message
                              : `Please select within the range of ${field.gap} days`
                          );
                          handleInputChange(key, null);
                          return;
                        }

                        handleInputChange(key, [
                          startDate.format("YYYY-MM-DD"),
                          endDate.format("YYYY-MM-DD"),
                        ]);
                      } else {
                        handleInputChange(key, null);
                      }
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field)}
                    style={{ width: "100%" }}
                  />
                </div>
              </Col>
            );

          case "calendar_yearmonth":
            return (
              <Col key={key} span={8} style={{ marginBottom: 24 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label style={{ marginBottom: 4, fontWeight: 500 }}>{field.label}</label>
                  <DatePicker
                    value={(formState[key] && formState[key].value) ?
                      moment(formState[key].value)
                      : null
                    }
                    format={"MMM-YY"}
                    className="antd_dateform-control"
                    picker="month"
                    placeholder="Select Month"
                    onChange={(e) => {
                      let selectedDate = null;
                      if (e) {
                        const monthDate = moment(e).format("YYYY-MM");
                        selectedDate = `${monthDate}-01`;
                      }
                      handleInputChange(key, selectedDate);
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field, "months")}
                    style={{ width: "100%" }}
                  />
                </div>
              </Col>
            );

          case "calendar_yearmonthrange":
            return (
              <Col key={key} span={8} style={{ marginBottom: 24 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label style={{ marginBottom: 4, fontWeight: 500 }}>{field.label}</label>
                  <RangePicker
                    value={(formState[key] && formState[key].value) ? [
                      moment(formState[key].value[0]),
                      moment(formState[key].value[1])
                    ] : null}
                    format={"MMM-YY"}
                    className="antd_dateform-control"
                    picker="month"
                    placeholder={["Start Month", "End Month"]}
                    onChange={(e) => {
                      if (e && e.length === 2) {
                        const startDate = moment(e[0]).startOf("month");
                        const endDate = moment(e[1]).endOf("month");

                        if (field.gap && endDate.diff(startDate, "months") > field.gap) {
                          setErrorWindowActive(true);
                          setErrorWindowMessage(
                            field.error_message
                              ? field.error_message
                              : `Please select within the range of ${field.gap} months`
                          );
                          handleInputChange(key, null)
                          return;
                        }

                        handleInputChange(key, [
                          startDate.format("YYYY-MM-DD"),
                          endDate.format("YYYY-MM-DD"),
                        ]);
                      } else {
                        handleInputChange(key, null);
                      }
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field, "months")}
                    style={{ width: "100%" }}
                  />
                </div>
              </Col>
            );

          case "textbox":
            return (
              <Col key={key} span={8} style={{ marginBottom: 24 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label style={{ marginBottom: 4, fontWeight: 500 }}>{field.label}</label>
                  <Input
                    name={key}
                    value={formState[key].value}
                    onChange={e => handleTextboxChange(key, e.target.value)}
                    onBlur={e => handleInputChange(key, e.target.value, true)}
                    style={{ width: "100%" }}
                  />
                  {field.status === 0 ? (
                    <span className="errmsg">
                      {field.error_message}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            );

          default:
            return null;
        }
      })}
    </Row>
  );
};

export default DynamicForm;
